/* Legend Skyline – Quick-add popup styling on every page (Home, Collection...)
   The Product Page builds <style id="ls-qa-css"> from the main-product section styles.
   Other pages don't have that section, so we fetch one product page once, build the
   same CSS and cache it for the session. */
(function () {
  var KEY = 'lsQaCss:v1';
  var SEC = /#shopify-section-template--\d+__main/g;
  var loading = false;

  function inject(css) {
    if (!css || document.getElementById('ls-qa-css')) return;
    var st = document.createElement('style');
    st.id = 'ls-qa-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function build(url) {
    if (loading || document.getElementById('ls-qa-css') || !url) return;
    loading = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var css = '';
        doc.querySelectorAll('style').forEach(function (s) {
          var t = s.textContent;
          SEC.lastIndex = 0;
          if (SEC.test(t)) css += t.replace(SEC, 'quick-add-modal .quick-add-modal__content-info');
        });
        if (css) {
          try { sessionStorage.setItem(KEY, css); } catch (e) {}
          inject(css);
        }
      })
      .catch(function () {})
      .then(function () { loading = false; });
  }

  function productUrlFrom(el) {
    var card = el.closest('.card-wrapper, .card, li');
    var a = card && card.querySelector('a[href*="/products/"]');
    return a ? a.href.split('?')[0].split('#')[0] : '';
  }

  var cached = null;
  try { cached = sessionStorage.getItem(KEY); } catch (e) {}
  if (cached) inject(cached);

  ['pointerenter', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.quick-add__submit, .quick-add modal-opener button');
      if (btn) build(productUrlFrom(btn));
    }, true);
  });

  /* warm up when the browser is idle so the popup is styled on first click */
  function warm() {
    var a = document.querySelector('.quick-add__submit');
    if (a) build(productUrlFrom(a));
  }
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
  else setTimeout(warm, 2500);
})();
